module.exports = __webpack_public_path__ + "static/media/af.1d73ae27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/af.svg
// module id = 44
// module chunks = 0